import {
    FETCH_LATEST_POWER_TO_WEIGHT_FETCHING,
    FETCH_LATEST_POWER_TO_WEIGHT_FAIL,
    FETCH_LATEST_POWER_TO_WEIGHT_SUCCESS,
    FETCH_LATEST_POWER_TO_WEIGHT
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    ftp: [],
    hasWeight: true,
    isFetching: false
};

const fetchLatestFTPFetching = (state) => ({
    ...state,
    isFetching: true
});

const fetchLatestFTPFail = (state) => ({
    ...state,
    isFetching: false
});

export const isLatestFTPFetching = (state) => {
    return state.ftp.isFetching;
};

const fetchLatestPowerToWeightSuccess = (state, { powerToWeight }) => ({
    ...state,
    hasWeight:
        Array.isArray(powerToWeight) &&
        ((powerToWeight[0] && powerToWeight[0].weight) || (powerToWeight[1] && powerToWeight[1].weight)),
    ftp: Array.isArray(powerToWeight) ? powerToWeight : [],
    isFetching: false
});

const handlers = {
    [FETCH_LATEST_POWER_TO_WEIGHT_FETCHING]: fetchLatestFTPFetching,
    [FETCH_LATEST_POWER_TO_WEIGHT_FAIL]: fetchLatestFTPFail,
    [FETCH_LATEST_POWER_TO_WEIGHT_SUCCESS]: fetchLatestPowerToWeightSuccess
};

export default function ftp(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export const fetchLatestPowerToWeight = (payload) => ({
    type: FETCH_LATEST_POWER_TO_WEIGHT,
    payload
});
